import React from "react";
import Particles, { ParticlesProvider } from "@tsparticles/react";
// import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.

// Must be a stable reference: @tsparticles/react throws when init changes between renders
const initEngine = async (engine) => {
    await loadSlim(engine);
};

const ParticlesComponent = () => {
    const particlesLoaded = (container) => {
        // console.log(container);
    };

    return (
        <ParticlesProvider init={initEngine}>
        <Particles
            id="tsparticles"
            particlesLoaded={particlesLoaded}
            options={{
                preset: "links",
                background: {
                    opacity: 0
                },
                fullScreen: {
                    enable: true,
                    // zIndex: -1,
                },
                detectRetina: true,
                fpsLimit: 120,
                motion: {
                    disable: false,
                    reduce: {
                        factor: 4,
                        value: true,
                    }
                },
                interactivity: {
                  events: {
                      onClick: {
                          enable: true,
                          mode: "push",
                      },
                      
                      resize: true,
                  },
                  modes: {
                      push: {
                          quantity: 4,
                      },
                      
                  },
              },
                particles: {
                    color: {
                        value: "#001752",
                      },
                      animation: {
                        enable: true,
                        speed: 50,
                        sync: false,
                      },
                      links: {
                        color: {
                          value: "#001752",
                        },
                        distance: 100,
                        enable: true,
                        frequency: 1,
                        opacity: 0.7,
                        width: 1,
                      },
                      move: {
                        enable: true,
                        speed: 0.5,
                      },
                      number: {
                        density: {
                          enable: true,
                          area: 800,
                          factor: 1000,
                        },
                        limit: 0,
                        value: 50,
                      },
                      opacity: {
                        random: {
                          enable: true,
                          minimumValue: 0.3,
                        },
                        value: 0.5,
                        animation: {
                          destroy: "none",
                          enable: true,
                          minimumValue: 0.3,
                          speed: 0.5,
                          startValue: "random",
                          sync: false,
                        },
                      },
                      size: {
                        random: {
                          enable: true,
                          minimumValue: 1,
                        },
                        value: 3,
                        animation: {
                          destroy: "none",
                          enable: true,
                          minimumValue: 1,
                          speed: 3,
                          startValue: "random",
                          sync: false,
                        },
                      }                      
                }
            }}
        />
        </ParticlesProvider>
    );
};

// Options are created inline, so skip re-renders of the parent (e.g. on a language change)
export default React.memo(ParticlesComponent);